import axios from 'axios';
import authHeader from '../auth-header'
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getPengajuanLog = 'pengajuan-lanjutan';

class PengajuanUjianLanjutanService {
    
    getPengajuanLog(currentPage, pageSize, filter, status) {

        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            status: status
        };
        
        return axios.get(
            API_URL + getPengajuanLog ,
        {
            params : data,
            headers: authHeader()
        });
    }

    countQuery() {
        return axios.get(API_URL + 'pengajuan-lanjutan-count-item',{headers:authHeader()});
    }

    approve(id, status) {
        var data = {
            id:id,
            status_pua: status
        }

        return axios.put(API_URL + 'set-approval-lanjutan',data, {headers:authHeader()})
    }


}

export default new PengajuanUjianLanjutanService();